import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";
import { languageCodesConstants } from "../constants/i18nLanguageConstants";
import { LANGUAGE_TOKEN, saveToken, getToken } from "../utils/tokenUtils";

let userLanguage = getToken(LANGUAGE_TOKEN);
let fallbackLng = ["en"];
if (userLanguage) fallbackLng = [userLanguage];

i18n
  .use(Backend)
  .use(initReactI18next)
  .init(
    {
      fallbackLng,
      backend: {
        loadPath: "/i18n/translations/{{lng}}/{{ns}}.json",
      },
      ns: ["common", "flashHire"],
      defaultNS: "common",
      react: {
        useSuspense: true,
        wait: true,
      },
    },
    err => {
      if (err) {
        console.log(err);
      }
    }
  );

i18n.loadNamespaces(["common", "flashHire"], err => {
  if (err) {
    console.log(err);
  }
});

export default i18n;

export const changeI18nLanguage = (languageCode: string) => {
  if (languageCode.length > 0) {
    i18n.changeLanguage(languageCode);
    saveToken(languageCode, LANGUAGE_TOKEN);
  } else {
    i18n.changeLanguage(languageCodesConstants.english);
    saveToken(languageCodesConstants.english, LANGUAGE_TOKEN);
  }
  const assessment_id = localStorage.getItem("assessmentId") || "";
  if (["1", "3"].includes(assessment_id)) window.location.reload();
};
